import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';
import ElegirVentanas from './ElegirVentanas';

// 4-nov-2026: la empresa avisa que su cliente no puede el día que le propusimos y marca cuándo sí puede.
// El pedido vuelve a "por agendar" con esos días y al técnico y al admin les llega el aviso.
export default function ClienteNoPuedeSheet({ pedido, onCerrar, onListo }) {
    const [ventanas, setVentanas] = useState([]);
    const [guardando, setGuardando] = useState(false);
    const enviar = async () => {
        setGuardando(true);
        try {
            const r = await api.post(`/empresa/pedidos/${pedido.id}/cliente-no-puede`, { ventanas });
            toast.success('Listo: le buscamos otro día y te avisamos');
            onListo(r.data);
        } catch (e) {
            toast.error(e?.response?.data?.mensaje || 'No se pudo avisar');
        } finally { setGuardando(false); }
    };
    return (
        <ModalShell titulo="¿Qué días sí puede?" subtitulo={`${pedido.lugar || pedido.direccion} · pedido #${pedido.id}`} onCerrar={onCerrar}
            pie={<button type="button" disabled={guardando} onClick={enviar}
                className="w-full h-12 rounded-xl bg-[#C9341F] text-white font-black text-body active:scale-95 disabled:opacity-40">
                {guardando ? 'Enviando…' : ventanas.length ? 'Enviar' : 'Enviar sin días'}</button>}>
            <p className="text-caption text-muted mb-3">Marcá los días y horarios en que tu cliente puede recibirnos. Si no sabés, envialo igual y lo coordinamos por acá.</p>
            <ElegirVentanas value={ventanas} onChange={setVentanas} />
        </ModalShell>
    );
}
